import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterTagGroup = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterTagGroup'),
);
